import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card border-0 box-shadow border-radius-10 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  key: 0,
  class: "all-table scroll-bar h-524 mb-5"
}
const _hoisted_4 = { class: "table align-middle mb-0" }
const _hoisted_5 = { class: "ps-0" }
const _hoisted_6 = { class: "text-start text-dark" }
const _hoisted_7 = { class: "d-block text-dark" }
const _hoisted_8 = { class: "d-block text-dark" }
const _hoisted_9 = { class: "d-block text-dark" }
const _hoisted_10 = {
  key: 0,
  class: "badge rounded-pill bg-primary"
}
const _hoisted_11 = { class: "d-block text-dark" }
const _hoisted_12 = { class: "d-block text-dark" }
const _hoisted_13 = { class: "text-end text-center" }
const _hoisted_14 = { class: "dropdown action-opt" }
const _hoisted_15 = {
  class: "btn bg-transparent p-0",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"10vh"}
}
const _hoisted_21 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"20vh"}
}
const _hoisted_22 = {
  class: "offcanvas offcanvas-custom offcanvas-end",
  tabindex: "-1",
  id: "offcanvasRight",
  "aria-labelledby": "offcanvasRightLabel"
}
const _hoisted_23 = { class: "offcanvas-header border-bottom" }
const _hoisted_24 = {
  class: "offcanvas-title fs-18",
  id: "offcanvasRightLabel"
}
const _hoisted_25 = { class: "offcanvas-body" }

import { ref } from "vue"
import { useDashboardStore } from '@/stores/dashboard'
import { useReceiptStore } from '@/stores/receipt'
import { storeToRefs } from "pinia"
import { formatDate, truncateNames } from "@/utils/helper"
import ReceiptDetail from "@/components/Receipt/ReceiptDetail.vue"
import type { Receipt } from "@/types/receipt"
import type { ApiResult } from "@/types/auth"
import Swal from "sweetalert2"
import 'sweetalert2/src/sweetalert2.scss'
import useAuth from "@/use/useAuth"

import { Offcanvas } from "bootstrap"


export default /*@__PURE__*/_defineComponent({
  __name: 'LatestReceipts',
  setup(__props) {

const { latestReceipts } = storeToRefs(useDashboardStore())
const { isSuperAdmin } = useAuth()
const { downloadReceipt } = useReceiptStore()

const receiptData = ref<Receipt | null>(null)

const viewReceipt = (receiptId: number) => {
  receiptData.value = latestReceipts.value.find((receipt) => receipt.id === receiptId) ?? null

  const offcanvasElement = document.getElementById('offcanvasRight')
  if (offcanvasElement) {
    const offcanvas = new Offcanvas(offcanvasElement)
    offcanvas.show()
  }
}

const download = async (receiptNumber: string) => {
  const response: ApiResult = await downloadReceipt(receiptNumber)

  if (response.success) {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Receipt is downloaded successfully',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-title d-flex justify-content-between align-items-center mb-3" }, [
        _createElementVNode("h3", { class: "fw-medium fs-18 mb-0" }, "Recent Receipts")
      ], -1)),
      (!!_unref(latestReceipts).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: "text-dark fw-medium pt-0 pb-2 fs-14 ps-0",
                    scope: "col"
                  }, " Agency "),
                  _createElementVNode("th", {
                    class: "text-dark fw-medium pt-0 pb-2 fs-14",
                    scope: "col"
                  }, " Receipt Number "),
                  _createElementVNode("th", {
                    class: "text-dark fw-medium pt-0 pb-2 fs-14",
                    scope: "col"
                  }, " Created "),
                  _createElementVNode("th", {
                    class: "text-dark fw-medium pt-0 pb-2 fs-14",
                    scope: "col"
                  }, " Name "),
                  _createElementVNode("th", {
                    class: "text-dark fw-medium pt-0 pb-2 fs-14",
                    scope: "col"
                  }, " Amount "),
                  _createElementVNode("th", {
                    class: "text-dark fw-medium pt-0 pb-2 fs-14",
                    scope: "col"
                  }, " Fee "),
                  _createElementVNode("th", {
                    class: "text-dark fw-medium pt-0 pb-2 fs-14",
                    scope: "col"
                  })
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(latestReceipts), (doc) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: doc.id
                  }, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(doc.agencyName), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(doc.receiptNumber), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatDate)(doc.receiptDate)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(truncateNames)(doc.recipientName).text), 1),
                      (_unref(truncateNames)(doc.recipientName, 2).extra! > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " +" + _toDisplayString(_unref(truncateNames)(doc.recipientName, 2).extra) + " more ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_11, "₵" + _toDisplayString(doc.amount.toFixed(2)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_12, "₵" + _toDisplayString(doc.fee.toFixed(2)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", _hoisted_15, [
                          _createVNode(_component_vue_feather, { type: "more-horizontal" })
                        ]),
                        _createElementVNode("ul", _hoisted_16, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:;",
                              onClick: ($event: any) => (viewReceipt(doc.id))
                            }, [
                              _createVNode(_component_vue_feather, { type: "eye" }),
                              _cache[0] || (_cache[0] = _createTextVNode(" View ", -1))
                            ], 8, _hoisted_17)
                          ]),
                          (_unref(isSuperAdmin))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (download(doc.receiptNumber))
                                }, [
                                  _createVNode(_component_vue_feather, { type: "printer" }),
                                  _cache[1] || (_cache[1] = _createTextVNode(" Download ", -1))
                                ], 8, _hoisted_19)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_unref(latestReceipts).length < 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("h6", null, "Receipts have not been requested yet.", -1)
          ]))])),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h5", _hoisted_24, _toDisplayString(receiptData.value?.receiptNumber), 1),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "offcanvas",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_25, [
          (receiptData.value)
            ? (_openBlock(), _createBlock(ReceiptDetail, {
                key: 0,
                "receipt-data": receiptData.value
              }, null, 8, ["receipt-data"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})